var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],staticClass:"ms-action-icon-btn",class:{
		'ms-action-icon-btn--active': _vm.active,
		'ms-action-icon-btn--disabled': _vm.disabled,
	},on:{"click":_vm.onClick}},[(!_vm.hasSlotContent)?_c('div',{staticClass:"mi-new-v2 mi-20",class:_vm.icon}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }